 export class Document_signature_request {
	
	id: string;
	document_id: string;
	user_person_id: string;
	requested_by: string;
	requested_on: string;
	signature: string;
	signature_date: Date;
	email_address: string;
	terms_accepted: boolean;
	terms_understood: boolean;
	ip_address: string;
	parent_signature: string;
	emergency_contact_phone: string;
	person_name: string;
	person_id: string;

	constructor(values: Object = {}) {
		Object.assign(this, values);
	}


 }